<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <!--
    Background overlay, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
    Modal panel, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      To: "opacity-100 translate-y-0 sm:scale-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100 translate-y-0 sm:scale-100"
      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Create {{ templateType }} Template
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <div>
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Name
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              type="text"
              v-model="name"
              ref="name"
              placeholder="Discount template"
            />
          </div>
        </div>
        <div class="mt-4">
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            <div class="flex justify-between items-center my-2">
              <span>Content</span>
              <InsertVariableDropdown
                :templateType="templateType"
                @onItemClicked="insertAtCursor"
              />
            </div>
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <textarea
              style="    min-height: 240px;"
              ref="content"
              v-model="body"
              class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            v-if="!template"
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="onCreate"
          >
            Create
          </button>
          <button
            v-if="template"
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="onEdit"
          >
            Update
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import InsertVariableDropdown from "./InsertVaribleDropdown";

export default {
  components: {
    InsertVariableDropdown
  },
  props: {
    template: {
      type: Object
    },
    templateType: {
      type: String
    }
  },
  data() {
    return {
      name: "",
      body: "",
      helperText: `You can use any of the following variables in your template:
              firstName, lastName, orderNumber. You must wrap it with {}.
              <br><span>For example, {firstName}</span>
              `
    };
  },
  mounted() {
    this.$refs.name.focus();
    if (this.template) {
      this.name = this.template.name;
      this.body = this.template.body;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onCreate() {
      this.$emit("create", { body: this.body, name: this.name });
      this.close();
    },
    onEdit() {
      this.$emit("edit", { body: this.body, name: this.name });
      this.close();
    },
    insertAtCursor(myValue) {
      const myField = this.$refs.content;
      //IE support
      if (document.selection) {
        myField.focus();
        sel = document.selection.createRange(); // eslint-disable-line
        sel.text = myValue; // eslint-disable-line
      }
      //MOZILLA and others
      else if (myField.selectionStart || myField.selectionStart == "0") {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value =
          myField.value.substring(0, startPos) +
          myValue +
          myField.value.substring(endPos, myField.value.length);
      } else {
        myField.value += myValue;
      }
      this.body = myField.value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
